import { render, staticRenderFns } from "./Catalogus.vue?vue&type=template&id=30275da2&scoped=true"
import script from "./Catalogus.vue?vue&type=script&lang=js"
export * from "./Catalogus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30275da2",
  null
  
)

export default component.exports